module.exports = __webpack_public_path__ + "img/bg9.37598e0c.jpg";